import { MenusManagementType } from './types';

export const state: MenusManagementType = {
  menuCategoriesTab: null,
  menusTab: [],
  stepper: null,
  menuCategories: [],
  allergens: [],
  additives: [],
};
